// ============================================================================
// FINANCIAL SCHEMA — RDA ERP JURÍDICO (Fase 40)
// Artigo 59.2: Dualidade de Regimes (Competência + Caixa)
// ============================================================================

export const FINANCIAL_COLLECTION = 'financial_ledger';

// ─── STATUS DE TRANSAÇÃO (Artigo 59.3) ──────────────────────────────────────
export const TRANSACTION_STATUS = {
  PENDING:   'PENDING',    // Lançado, aguardando liquidação
  PAID:      'PAID',       // Liquidado / Recebido
  OVERDUE:   'OVERDUE',    // Vencido sem pagamento
  CANCELLED: 'CANCELLED',  // Cancelado / Estornado
};

// ─── TIPOS DE MOVIMENTO ──────────────────────────────────────────────────────
export const TRANSACTION_TYPES = {
  INCOME:  'INCOME',   // Entrada
  EXPENSE: 'EXPENSE',  // Saída
};

// ─── REGIME DE VISUALIZAÇÃO ──────────────────────────────────────────────────
export const VIEW_REGIME = {
  CASH:       'CASH',       // Caixa: usa paymentDate
  COMPETENCE: 'COMPETENCE', // Competência: usa competenceDate
};

// ─── CATEGORIAS (Artigo 59.4) ─────────────────────────────────────────────────
export const INCOME_CATEGORIES = [
  'Honorários Advocatícios',
  'Honorários de Sucumbência',
  'Consultoria Jurídica',
  'Contrato de Êxito',
  'Reembolso de Custas',
  'Outras Receitas',
];

export const EXPENSE_CATEGORIES = [
  'Custas Processuais',
  'Distribuição de Ações',
  'Perícias e Laudos',
  'Diligências',
  'Salários e Pró-Labore',
  'Aluguel e Ocupação',
  'Impostos e Tributos (ISS, IRPJ, CSLL)',
  'Tecnologia e Assinaturas',
  'Material de Escritório',
  'Contabilidade e Auditoria',
  'Publicidade e Marketing',
  'Outras Despesas',
];

// ─── SCHEMA DE TRANSAÇÃO (financial_ledger document) ─────────────────────────
// Artigo 59.2 — Dualidade obrigatória de datas
// {
//   id:               string  — doc.id do Firestore
//   type:             TRANSACTION_TYPES.*
//   status:           TRANSACTION_STATUS.*
//   amount:           number  — armazenado em centavos inteiros
//   description:      string
//   category:         string  — uma das constantes acima
//   competenceDate:   string  — ISO date "YYYY-MM-DD" (Fato gerador / Emissão)
//   paymentDate:      string | null — ISO date (Caixa / Liquidação real)
//   dueDate:          string | null — Vencimento
//   clientId:         string | null — FK → clients collection
//   workspaceId:      string | null — FK → autos_workspaces collection
//   processId:        string | null — FK → processos collection
//   notes:            string
//   isDeleted:        boolean
//   createdAt:        Timestamp
//   updatedAt:        Timestamp
//   createdBy:        string (uid)
// }

// ─── SALDO INICIAL (Artigo 59.1) ─────────────────────────────────────────────
// O saldo inicial é injetado via configuração (office_settings/financial),
// não é uma transação. Permite calibrar o ponto zero do caixa.
export const INITIAL_BALANCE_SETTING_KEY = 'rda_financial_initial_balance';

// ─── HELPER: monta o objeto de nova transação ─────────────────────────────────
export function buildTransaction({
  type = TRANSACTION_TYPES.INCOME,
  status = TRANSACTION_STATUS.PENDING,
  amountCents = 0,
  description = '',
  category = '',
  competenceDate = '',
  paymentDate = null,
  dueDate = null,
  clientId = null,
  workspaceId = null,
  processId = null,
  notes = '',
  createdBy = '',
} = {}) {
  return {
    type,
    status,
    amount: amountCents,
    description: String(description).trim(),
    category: String(category).trim(),
    competenceDate: String(competenceDate).trim(),
    paymentDate: paymentDate ? String(paymentDate).trim() : null,
    dueDate: dueDate ? String(dueDate).trim() : null,
    clientId: clientId || null,
    workspaceId: workspaceId || null,
    processId: processId || null,
    notes: String(notes).trim(),
    isDeleted: false,
    createdBy: String(createdBy).trim(),
  };
}

// ─── MAPEAMENTO CNPJ FORNECEDOR → ESCOPO (usado por useJsonPendencias) ───────
// Movido de src/features/finance/_shared/FinanceSharedUI.jsx (auditoria
// 10/09/2026, item menor 7 — organização, não segurança: CNPJ de fornecedor
// já é dado público no Cadastro Nacional, não é segredo).
export const ESCOPO_POR_FORNECEDOR_CNPJ = {
  '15.616.298/0001-36': 'recta', // Eloprint
};
